import { render, staticRenderFns } from "./UserBuyAgreeDialog.vue?vue&type=template&id=7c79a163&scoped=true"
import script from "./UserBuyAgreeDialog.vue?vue&type=script&lang=js"
export * from "./UserBuyAgreeDialog.vue?vue&type=script&lang=js"
import style0 from "./UserBuyAgreeDialog.vue?vue&type=style&index=0&id=7c79a163&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c79a163",
  null
  
)

export default component.exports